export const EVOUCHER_NOTIF_NUM_KEYS = {
	DAILY_NOTIF_TIME_AM_HH: 'evoucherNotif_dailyNotifAM_hh',
	DAILY_NOTIF_TIME_AM_MM: 'evoucherNotif_dailyNotifAM_mm',
	DAILY_NOTIF_TIME_PM_HH: 'evoucherNotif_dailyNotifPM_hh',
	DAILY_NOTIF_TIME_PM_MM: 'evoucherNotif_dailyNotifPM_mm',
};

export const SHOWS_NOTIF_NUM_KEYS = {
	SHOWS_DAILY_NOTIF_TIME_HH: 'showsNotif_dailyNotif_hh',
	SHOWS_DAILY_NOTIF_TIME_MM: 'showsNotif_dailyNotif_mm',
	SHOWS_DAILY_NOTIF_TIME_SS: 'showsNotif_dailyNotif_ss',
};

export const MENU_BOOL_KEYS = {
	MENU_TIER_POINTS_ENABLED: 'menu_isTierPointsEnabled',
	MENU_GV_ENABLED: 'menu_isGVEnabled',
	MENU_CALYPSO_ENABLED: 'menu_isCalypsoEnabled',
	MENU_RAFFLE_DRAW_ENABLED: 'menu_isRaffleDrawEnabled',
	MENU_INVITATIONS_ENABLED: 'menu_isInvitationsEnabled',
};

export const CARD_BOOL_KEYS = {
	CARD_QR_CODE_ENABLED: 'card_isQRCodeEnabled',
};

export const GENERIC_STRING_KEYS = {
	CASINO_PROMOTIONS_URL: 'string_casinoPromotionsUrl',
	LIFESTYLE_URL: 'string_lifestyleUrl',
	DIRECTORY_URL: 'string_directoryUrl',
	SHUTTLE_URL: 'string_shuttleUrl',
	NWR_HOTLINE: 'string_nwrHotline',
	WINFORD_HOTLINE: 'string_winfordHotline',
	EPIC_MILLIONS_SECRET_KEY: 'string_epicMillionsSecretKey',
};



// WEBPACK FOOTER //
// ./components/AppConfig/keys.js